export default "__VITE_ASSET__D7_rEy7e__"